import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  INCREMENT_PING_COUNT,
  RECEIVE_CUSTOMERS,
  RECEIVE_RECENT_TICKETS,
  SET_PING_COUNT,
} from "@/components/customer/internal/ducks/Actions"

const defaultState = {
  recentTickets: [],
  customers: [],
  pingCount: 0, // for checking whether a customer has been deleted
}

const internalCustomerReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_CUSTOMERS:
      return {
        ...oldState,
        customers: action.customers,
      }
    case SET_PING_COUNT:
      return {
        ...oldState,
        pingCount: action.pingCount,
      }

    case INCREMENT_PING_COUNT:
      return {
        ...oldState,
        pingCount: oldState.pingCount + 1,
      }

    case RECEIVE_RECENT_TICKETS:
      return {
        ...oldState,
        recentTickets: action.recentTickets,
      }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default internalCustomerReducer
